module.exports = __webpack_public_path__ + "img/alarm.36686ebe.png";